export const PRESET_SIZES = [50, 100, 250, 500, 800, 1200, 1600, 2000] as const;

export type ImageSize = (typeof PRESET_SIZES)[number];

export type ImageLoaderParams = {
  imageSize: number;
  quality?: number;
};
